import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { getItemLockedContent } from '../../../api/items';

import { generateItemCIDKey } from '../../../components/Items/utils/generateItemCIDKey';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

export const fetchItemLockedContent = createAsyncThunk(
  'items/fetchItemLockedContent',
  async ({ path }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const { data } = await getItemLockedContent(
        { path },
        {
          cancelToken: source.token,
        },
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
);

export const fetchItemLockedContentExtraReducers = builder => {
  builder
    .addCase(fetchItemLockedContent.pending, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg.path);
      checkAndSetLoadingWithId(
        state.items.lockedContent.request,
        action,
        itemCIDKey,
      );
    })
    .addCase(fetchItemLockedContent.fulfilled, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg.path);
      onMatchedRequest(
        state.items.lockedContent.request[itemCIDKey],
        action,
        () => {
          state.items.lockedContent.byId[itemCIDKey] =
            state.items.item.byId[itemCIDKey];
          state.items.lockedContent.byId[itemCIDKey].content = action.payload;
        },
      );
    })
    .addCase(fetchItemLockedContent.rejected, (state, action) => {
      handleRequestRejection(
        state.items.lockedContent.request[
          generateItemCIDKey(action.meta.arg.path)
        ],
        action,
      );
    });
};
